import React, { useState, useEffect } from 'react';
import axios from 'axios';
import apiURL from './Config';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

const RatesComponent = () => {
  const [rates, setRates] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);

  useEffect(() => {
    // Fetch current rates from the server
    axios.get(`${apiURL}/api/rates`)
      .then(response => {
        setRates(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching rates:', error);
        setLoading(false);
      });
  }, []);

  const handleChange = (region, key, value) => {
    setRates(prevRates => ({
      ...prevRates,
      [region]: {
        ...prevRates[region],
        [key]: parseFloat(value)
      }
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSaving(true);
    axios.post(`${apiURL}/api/rates`, rates, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      timeout: 2000 // 2 second timeout to handle backend proxy restart hang
    })
      .then(response => {
        setMessage('');
        setSaving(false);
        setShowSuccessAlert(true); // Show the MUI dialog
      })
      .catch(error => {
        // If it's a timeout, it means the server successfully wrote the file but restarted (dropping the connection)
        if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
          setMessage('');
          setSaving(false);
          setShowSuccessAlert(true); 
        } else {
          console.error('Error updating rates:', error);
          setMessage('Error updating rates');
          setSaving(false);
        }
      });
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      {/* MUI Success Alert Dialog */}
      <Dialog 
        open={showSuccessAlert} 
        onClose={() => setShowSuccessAlert(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle style={{ backgroundColor: '#4caf50', color: 'white', textAlign: 'center' }}>
          Success!
        </DialogTitle>
        <DialogContent style={{ padding: '20px', textAlign: 'center', marginTop: '10px' }}>
          <Typography variant="h6">
            Rates updated successfully!
          </Typography>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center', paddingBottom: '20px' }}>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={() => setShowSuccessAlert(false)}
            style={{ minWidth: '100px' }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <div className='main-content'>
        <div className='rates'>
          <h2>Update Shipping Rates</h2>
          {message && <p style={{ color: 'red' }}>{message}</p>}
          <form onSubmit={handleSubmit}>
            <table style={{ 
              width: '100%', 
              borderCollapse: 'collapse', 
              marginBottom: '20px',
              border: '1px solid #ddd'
            }}>
              <thead>
                <tr style={{ backgroundColor: '#f5f5f5' }}>
                  <th style={{ padding: '12px', textAlign: 'left', border: '1px solid #ddd', fontWeight: 'bold' }}>Region</th>
                  <th style={{ padding: '12px', textAlign: 'center', border: '1px solid #ddd', fontWeight: 'bold' }}>0-250g</th>
                  <th style={{ padding: '12px', textAlign: 'center', border: '1px solid #ddd', fontWeight: 'bold' }}>251-500g</th>
                  <th style={{ padding: '12px', textAlign: 'center', border: '1px solid #ddd', fontWeight: 'bold' }}>501-1000g</th>
                  <th style={{ padding: '12px', textAlign: 'center', border: '1px solid #ddd', fontWeight: 'bold' }}>Additional per 500g</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(rates).map(region => (
                  <tr key={region}>
                    <td style={{ padding: '12px', border: '1px solid #ddd', fontWeight: 'bold', backgroundColor: '#f9f9f9' }}>{region}</td>
                    <td style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>
                      <input
                        type="number"
                        value={rates[region].amount250}
                        onChange={(e) => handleChange(region, 'amount250', e.target.value)}
                        style={{ padding: '8px', width: '80px', border: '1px solid #ccc', borderRadius: '4px', textAlign: 'center' }}
                      />
                    </td>
                    <td style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>
                      <input
                        type="number"
                        value={rates[region].amount500}
                        onChange={(e) => handleChange(region, 'amount500', e.target.value)}
                        style={{ padding: '8px', width: '80px', border: '1px solid #ccc', borderRadius: '4px', textAlign: 'center' }}
                      />
                    </td>
                    <td style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>
                      <input
                        type="number"
                        value={rates[region].amount1000}
                        onChange={(e) => handleChange(region, 'amount1000', e.target.value)}
                        style={{ padding: '8px', width: '80px', border: '1px solid #ccc', borderRadius: '4px', textAlign: 'center' }}
                      />
                    </td>
                    <td style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>
                      <input
                        type="number"
                        value={rates[region].additional500}
                        onChange={(e) => handleChange(region, 'additional500', e.target.value)}
                        style={{ padding: '8px', width: '80px', border: '1px solid #ccc', borderRadius: '4px', textAlign: 'center' }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <button type="submit" disabled={saving} style={{
              backgroundColor: saving ? '#ccc' : '#007bff',
              color: 'white',
              padding: '10px 20px',
              border: 'none',
              borderRadius: '4px',
              cursor: saving ? 'not-allowed' : 'pointer',
              fontSize: '16px'
            }}>
              {saving ? 'Updating...' : 'Update Rates'}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default RatesComponent;